import { addOpacityToRGBA } from 'common/utils/color-utils'
import styled, { css } from 'styled-components'

interface TimeSlotButtonUiProps {
  selectedBackgroundColor: string
  isSelected: boolean
}

const TIME_SLOT_OPACITY = 0.1

export const TimeSlotButtonUi = styled.button<TimeSlotButtonUiProps>`
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
  align-items: center;
  font-size: 14px;
  line-height: 13px;

  outline: none;
  border: 1px solid #b5c3d580;
  border-radius: 10px;
  background-color: #fff;
  cursor: pointer;
  ${p =>
    p.isSelected &&
    css`
      color: ${p.selectedBackgroundColor};
      background-color: ${addOpacityToRGBA(
        p.selectedBackgroundColor,
        TIME_SLOT_OPACITY,
      )};
      border-color: ${p.selectedBackgroundColor};
    `}

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      padding: 10px;
    `}

  ${p => p.theme.phone} {
    padding: 10px;
  }
`
